module.exports = __webpack_public_path__ + "img/3K6A1578web.a5257f06.jpg";